import { Component, Inject, Input } from '@angular/core';
import { DropdownToggleService } from '@shared/services/dropdown-toggle.service';
import { Ticket } from '../../models/tickets';
import { AppUtilService } from '@shared/services/app-util.service';
import { TeamHourComponent } from '../team-hour/team-hour.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TicketsService } from '../../services/tickets.service';
import { AddTeamMemberAndHourComponent } from '../add-team-member-and-hour/add-team-member-and-hour.component';

@Component({
  selector: 'app-team-hours-popup',
  standalone:false,
  templateUrl: './team-hours-popup.component.html',
  styleUrl: './team-hours-popup.component.css'
})
export class TeamHoursPopupComponent {
  @Input() ticketId: string;
 @Input() getTicket: Ticket;
isChangeAnything=0;
isEstimatedTimeOnly = false;
changeWorker = false;


constructor(
  protected dropdownService: DropdownToggleService,
  public appUtilService: AppUtilService,
    private dialogRef: MatDialogRef<TeamHourComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ticketId: string,ticket:Ticket, isEstimatedTimeOnly: boolean, changeworker: boolean},
    public ticketService: TicketsService,
    private dialog:MatDialog,
){
  if(this.data){
      this.ticketId = this.data?.ticketId;
      this.getTicket=this.data?.ticket;
      this.isEstimatedTimeOnly = this?.data.isEstimatedTimeOnly;
      this.changeWorker = this.data?.changeworker;
    }
}
  cancel(){
    if(this.isChangeAnything){
        this.dialogRef.close(true);
      }
      else{
        this.dialogRef.close(false);
      }
  }

  AddTeamMemberAndHour(): void {
       this.dropdownService.hideAllDropdowns();
        const width = this.SetDialogWidthTeamMember();
        this.ticketService.selectedTicketId =this.getTicket.id;
        this.ticketService.ticketLaborList =this.getTicket.ticketLabor;
        const dialog = this.dialog.open(AddTeamMemberAndHourComponent, {
          minWidth: width,
          width: width,
          // minHeight: '545px',
          // maxHeight: '545px',
          panelClass: 'overflow_visible',
          hasBackdrop: true,
          disableClose: true,
          data: {
            estimatedHoursOnly: this.isEstimatedTimeOnly,
          },
        });
        dialog.afterClosed().subscribe(async (result) => {
          if (!result) return;

          if (result) {
            this.isChangeAnything = 1;
          } 
        });
      }


  SetDialogWidthTeamMember(): string {
        let returnWidth;
        const windowWidth = window.innerWidth;
        switch (true) {
          case windowWidth < 450: {
            returnWidth = '94vw';
            break;
          }
          case windowWidth >= 450 && windowWidth < 750: {
            returnWidth = '94vw';
            break;
          }
          default:
            returnWidth = '480px';
        }
        return returnWidth;
  }



}
